import { createSelector } from "reselect";

const getHasSubchapterKey = (state) => !!state.route.params.subchapterKey;

export const getIsSubchapterRenderedSomewhere = createSelector(
  [getHasSubchapterKey],
  (hasSubchapterKey) => hasSubchapterKey,
);

export default getIsSubchapterRenderedSomewhere;
